export const allowList = [
  "www.emprisebank.com",
  "emprisebank.com",
  "securemail.emprisebank.com",
  "applink.bank2business.net",
  "cibng.ibanking-services.com",
  "emprisebank.ebanking-services.com",
  "emprise.rewardschoices.com",
  "emprisebank.mortgagewebcenter.com",
  "secureapplication.emprisebank.com",
  "iaf.infinity.com",
  "www.myaccountaccess.com",
  "online1.elancard.com",
  "emprisebank.force.com",
  "oac.fmsiportal.com",
  "emprisebank.cashplease.com",
  "open.emprisebank.com",
  "creditcardlearnmore.com",
  "onlinebanking.emprisebank.com",
  "emprisebank2.na2.echosign.com",
  "emprisebank.royalreferralcenter.com",
  "assets-us-01.kc-usercontent.com",
  "emprisebank.screenconnect.com",
  "learn.emprisebank.com",
];
